import { createFileRoute } from '@tanstack/react-router';

import { DmaMatrixPage } from '@/features/esg/dma/components/DmaMatrixPage';

export const Route = createFileRoute('/_authenticated/esg/double-materiality/$assessmentId/matrix')({
  component: DmaMatrixRoute,
});

function DmaMatrixRoute() {
  const { assessmentId } = Route.useParams();
  return <DmaMatrixPage assessmentId={assessmentId} />;
}
